import React from 'react';

import chevron from './Chevron';
import facebook from './Facebook';
import instagram from './Instagram';
import linkedin from './Linkedin';
import mail from './Mail';
import twitter from './Twitter';
import whatsapp from './Whatsapp';

import { theme } from '../../styles/theme';
import colourMatching from '../../utils/colourMatching';
import isDarkColour from '../../utils/isDarkColour';

const iconMap = {
  chevron,
  facebook,
  instagram,
  linkedin,
  mail,
  twitter,
  whatsapp,
};

/**
 * Renders an SVG icon
 * @param {Object} props
 * @param {"chevron"|"facebook"|"instagram"|"linkedin"|"mail"|"twitter"|"whatsapp"} props.icon - Name of the icon to display
 * @param {boolean} [props.colourScheme]
 * @param {boolean} [props.withBackground] - Adds circular background around the icon
 * with color dependent on {light} and transparent logo fill
 */
const Icon = ({ icon, colourScheme, withBackground, ...iconProps }) => {
  const SelectedIcon = iconMap[icon];

  const isDark = isDarkColour(colourScheme);

  const backgroundColor = withBackground
    ? isDark
      ? theme.colors.lightText
      : theme.colors.text
    : 'transparent';

  const iconColor = withBackground
    ? colourMatching(colourScheme)
    : isDark
    ? theme.colors.lightText
    : theme.colors.text;

  return SelectedIcon ? (
    <SelectedIcon
      backgroundColor={backgroundColor}
      iconColor={iconColor}
      {...iconProps}
    />
  ) : null;
};

export default Icon;
